// src/i18n.js
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend"; // To load translation files from the server
import LanguageDetector from "i18next-browser-languagedetector"; // To detect the user's language
import { SUPPORTED_LANGUAGES } from "./languages";

const supportedLngs = SUPPORTED_LANGUAGES.map((language) => language.code);

i18next
  .use(Backend) // Use Backend plugin to load translation files
  .use(LanguageDetector) // Detect user's language
  .use(initReactI18next) // Pass i18next instance to react-i18next
  .init({
    fallbackLng: "en",
    supportedLngs,
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: [
        "localStorage",
        "navigator",
        "htmlTag",
        "querystring",
        "path",
        "subdomain",
      ],
      caches: ["localStorage"],
      lookupQuerystring: "lng",
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense to avoid waiting for translations
    },
    backend: {
      loadPath: "/locales/language_{{lng}}.json", // Path to your JSON translation files
    },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18next.resolvedLanguage || "en";
}

i18next.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

export default i18next;
